<div 
  class="app-logo-container"
  [class]="logoClasses"
  (click)="onLogoClick()"
>
  <img 
    [src]="src" 
    [alt]="alt"
    [style.width]="width"
    [style.height]="height"
    class="app-logo__image"
  />
  
  <div 
    *ngIf="showVersion"
    [class]="versionClasses"
  >
    {{ versionText }}
  </div>
</div>
